import API_CONFIG from './api_config';

/**
 * Asynchronously fetch company data from the backend.
 *
 * Constructs the request URL using the provided company name and sends a POST request.
 * Returns the parsed JSON response if successful, or throws an error on failure.
 *
 * @param {string} name - The company name to search for.
 * @returns {Promise<Object>} Promise resolving with the company data.
 * @throws {Error} If the network response is not ok.
 */
const fetchCompanyData = async (name) => {
  try {
    const url = API_CONFIG.BACKEND_URL + '/search-company?companyName=' + name;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) throw new Error('Network response was not ok');

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export default fetchCompanyData;
